import React, { useRef } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import Scrollable from '../scrollable/Scrollable';

interface VirtualizedListProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  estimateSize?: (index: number) => number;
  overscan?: number;
}

const VirtualizedList = <T extends { id: string | number }>({
  items,
  renderItem,
  estimateSize = () => 50,
  overscan = 5,
}: VirtualizedListProps<T>) => {
  const listRef = useRef<HTMLDivElement>(null);

  const rowVirtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => listRef.current,
    estimateSize,
    overscan,
  });

  return (
    <Scrollable containerRef={listRef} scrollAdditionClassName="scrollable__wrapper">
      <ul
        className="generic-list"
        style={{ height: `${rowVirtualizer.getTotalSize()}px` }}
      >
        {rowVirtualizer.getVirtualItems().map((virtualRow) => {
          const item = items[virtualRow.index];

          return (
            <li
              key={item.id}
              className="virtualized-list__item"
              style={{
                transform: `translateY(${virtualRow.start}px)`,
                height: `${virtualRow.size}px`,
              }}
            >
              {renderItem(item, virtualRow.index)}
            </li>
          );
        })}
      </ul>
    </Scrollable>
  );
};

export default VirtualizedList;
